(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product--how-to-use"]) return;
  try {
    
  jQuery(function() {
    initHowToUseCarousel();
  });

  // slick init
  function initHowToUseCarousel() {
    var $carousel = jQuery('.how-to-use__content ol');

    if ($carousel.length) {
      var carouselSettings = {
        slidesToScroll: 1,
        rows: 0,
        infinite: false,
        arrows: false,
        slide: 'li',
        dots: true,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [{
          breakpoint: 768,
          settings: "unslick"
        }]
      };
      if (jQuery(window).width() > 767) {
        if ($carousel.hasClass('.slick-initialized')) {
          $carousel.slick('unslick');
        }
      } else {
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.slick(carouselSettings);
        }
      }
    }
  }

  $(window).resize(function() {
    initHowToUseCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"]) return;
  try {
    
  jQuery(function() {
    initIngredientsCarousel();
  });

  // slick init
  function initIngredientsCarousel() {
    var $carousel = jQuery('.ingredients-carousel');
    var $photos = jQuery('.ingredient-photos');

    if ($photos.length && $carousel.length) {
      var carouselSettings = {
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: true,
        asNavFor: '.ingredient-photos',
        responsive: [{
          breakpoint: 768,
          settings: "unslick"
        }]
      };

      var photosSettings = {
        slidesToScroll: 1,
        rows: 0,
        arrows: false,
        draggable: false,
        responsive: [{
          breakpoint: 768,
          settings: "unslick"
        }]
      };

      if (jQuery(window).width() > 767) {
        if (!$carousel.hasClass('slick-initialized') || !$photos.hasClass('slick-initialized')) {
          $carousel.slick(carouselSettings);
          $photos.slick(photosSettings);
        }
      } else {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
          $photos.slick('unslick');
        }
      }
    }
  }

  $(window).resize(function() {
    initIngredientsCarousel();
  });

  } catch(e) { console.error(e); }
})();

})();
